module.exports = __webpack_public_path__ + "img/mobile.cbf51080.png";